export default (word, time) => {
  if (!word || word.length === 0) {
    return;
  }
  var toastCover = document.createElement('div'),
    toastCoverExist = document.getElementById("toastCover");
  if (toastCoverExist) {
    document.body.removeChild(toastCoverExist);
  }
  if (word.length <= 10) {
    toastCover.style.cssText = "min-width: 1.40rem;position: fixed;top: 50%;left: 50%;transform: translate(-50%, -50%);-webkit-transform: translate(-50%, -50%);z-index: 999999;height: 0.42rem;line-height: 0.42rem;padding: 0.2rem 0.25rem;" +
      "background-color: rgba(0, 0, 0, 0.8);border-radius: 0.1rem;font-size: 0.26rem;color: #fff;text-align: center;";
  } else {
    toastCover.style.cssText = "width: 5rem;position: fixed;top: 50%;left: 50%;transform: translate(-50%, -50%);-webkit-transform: translate(-50%, -50%);z-index: 999999;line-height: 0.42rem;padding: 0.2rem 0.25rem;" +
      "background-color: rgba(0, 0, 0, 0.8);border-radius: 0.10rem;font-size: 0.26rem;color: #fff;text-align: center;";
  }
  toastCover.id = 'toastCover';
  toastCover.innerText = word;
  document.body.appendChild(toastCover);


  if (time === 0) {
    return () => {
      var t = document.querySelector('#toastCover')
      if (t) {
        t.parentNode.removeChild(t);
      }
    }
  }

  if (window.toastTimeout) {
    clearTimeout(window.toastTimeout);
  }
  window.toastTimeout = setTimeout(function () {
    if (document.querySelector('#toastCover')) {
      toastCover.parentNode.removeChild(toastCover);
    }
  }, time || 2000)
}

